import { Injectable, OnDestroy } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ActivatedRouteSnapshot, ResolveEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import {EnvService} from '../env/env.service';
@Injectable()
export class ApplicationInsightsService implements OnDestroy {

  private isConfigured = false;
  private routerSubscription: Subscription;
  private appInsights = null

  constructor(private router: Router, environmentService: EnvService) {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environmentService.get().appInsightsInstrumentationKey
      }
    });
    if (environmentService.get().appInsightsInstrumentationKey) {
      this.isConfigured = true;
    }

    if (this.isConfigured) {
      console.log('Loaded Application Insights!');
      this.appInsights.loadAppInsights();

      this.routerSubscription = this.router.events
        .pipe(filter(event => event instanceof ResolveEnd))
        .subscribe((event: ResolveEnd) => {
          const activatedComponent = this.getActivatedComponent(event.state.root);
          if (activatedComponent) {
            this.logPageView(`${activatedComponent.name} ${this.getRouteTemplate(event.state.root)}`, event.urlAfterRedirects);
          }
        });
    } else {
      console.log('Application Insights not loaded! Not configured!');
    }
  }

  ngOnDestroy(): void {
    if (this.isConfigured) {
      if (this.routerSubscription) {
        this.routerSubscription.unsubscribe();
      }
    }
  }

  setUserId(userId: string) {
    if (this.isConfigured) {
      this.appInsights.setAuthenticatedUserContext(userId);
    }
  }

  clearUserId() {
    if (this.isConfigured) {
      this.appInsights.clearAuthenticatedUserContext();
    }
  }

  logPageView(name?: string, uri?: string) {
    if (this.isConfigured) {
      this.appInsights.trackPageView({ name, uri });
    }
  }

  logEvent(name: string, properties?: any, measurements?: any) {
    if (this.isConfigured) {
      this.appInsights.trackEvent({ name: name, properties: properties }, measurements);
    }
  }

  logExceptionMessage(errorMessage: string) {
    if (this.isConfigured) {
      this.logException(new Error(errorMessage));
    }
  }

  logException(error: Error) {
    if (this.isConfigured) {
      this.appInsights.trackException({ exception: error });
    }
  }

  private getActivatedComponent(snapshot: ActivatedRouteSnapshot): any {
    if (snapshot.firstChild) {
      return this.getActivatedComponent(snapshot.firstChild);
    }

    return snapshot.component;
  }

  private getRouteTemplate(snapshot: ActivatedRouteSnapshot): string {
    let path = '';
    if (snapshot.routeConfig) {
      path += snapshot.routeConfig.path;
    }

    if (snapshot.firstChild) {
      return path + this.getRouteTemplate(snapshot.firstChild);
    }

    return path;
  }
}
